// Service URLs held by a backend configuration, in the order they are shown in the form and table
export const SERVICE_FIELDS = [
  {name: "conversationLoggerApi", label: "Conversation Logger API", placeholder: "https://logger.example.com/api"},
  {name: "chatbotApi", label: "Chatbot API", placeholder: "https://chatbot.example.com/api"},
  {name: "mcpRegistry", label: "MCP Registry", placeholder: "https://mcp.example.com/registry"},
  {name: "initiateCallApi", label: "Initiate Call API", placeholder: "https://calls.example.com/api/initiate"},
  {name: "knowledgeManagerApi", label: "Knowledge Manager API", placeholder: "https://knowledge.example.com/api"},
  // only the domain: the browser phone connects to wss://<pbx>/ws (see pbxWebSocketUrl)
  {name: "pbx", label: "PBX", placeholder: "pbx.example.com"},
];

// The browser phone's WebSocket for a backend configuration's pbx, null when it has none. Tolerates a pasted
// scheme or path ("https://pbx.example.com/", "wss://pbx.example.com/ws"): only the host (and port) is used.
export const pbxWebSocketUrl = (pbx) => {
  const host = String(pbx || "").trim().replace(/^[a-z]+:\/\//i, "").replace(/\/.*$/, "");
  return host ? `wss://${host}/ws` : null;
};
